(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1389],{

/***/ 92290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var NoSsr = function NoSsr(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: props.children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.resolve(NoSsr);
}, {
  ssr: false
}));

/***/ }),

/***/ 18958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useFavorites; }
/* harmony export */ });
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50029);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _store_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4062);
/* harmony import */ var app_model_category__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51027);
/* harmony import */ var app_store_slices_user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38886);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var services_hooks_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90413);
/* harmony import */ var _navigation_hook__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26793);









var useFavorites = function useFavorites(customAuthGuard) {
  var dispatch = (0,_store_store__WEBPACK_IMPORTED_MODULE_1__/* .useAppDispatch */ .TL)();
  var navigatePath = (0,_navigation_hook__WEBPACK_IMPORTED_MODULE_5__/* .useNavigatePath */ .xQ)();

  var _useAppSelector = (0,_store_store__WEBPACK_IMPORTED_MODULE_1__/* .useAppSelector */ .CG)(app_store_slices_user__WEBPACK_IMPORTED_MODULE_2__/* .selectUserState */ .tH),
      session = _useAppSelector.session,
      favorites = _useAppSelector.favorites,
      favoritesLoading = _useAppSelector.favoritesLoading;

  var _usePostAccountUsersM = (0,services_hooks_hooks__WEBPACK_IMPORTED_MODULE_4__/* .usePostAccountUsersMePresets */ .Ww)(),
      addFavorite = _usePostAccountUsersM.mutateAsync,
      addToFavoriteLoading = _usePostAccountUsersM.isLoading;

  var _useDeleteAccountUser = (0,services_hooks_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useDeleteAccountUsersMePresets */ .$$)(),
      deleteFavorite = _useDeleteAccountUser.mutateAsync,
      deleteFavoriteLoading = _useDeleteAccountUser.isLoading;

  var favoritesPending = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () {
    return favoritesLoading || addToFavoriteLoading || deleteFavoriteLoading;
  }, [favoritesLoading || addToFavoriteLoading || deleteFavoriteLoading]);

  var addToFavorites = /*#__PURE__*/function () {
    var _ref = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(category) {
      var isPlaying,
          _args = arguments;
      return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isPlaying = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
              _context.prev = 1;
              _context.next = 4;
              return addFavorite({
                requestBody: [{
                  permalink: category.permalink
                }],
                queryParams: {
                  live: isPlaying
                }
              });

            case 4:
              dispatch(app_store_slices_user__WEBPACK_IMPORTED_MODULE_2__/* .userActions.loadFavorites */ .hI.loadFavorites());
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    }));

    return function addToFavorites(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var removeFromFavorites = /*#__PURE__*/function () {
    var _ref2 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(category) {
      var isPlaying,
          _args2 = arguments;
      return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              isPlaying = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
              _context2.prev = 1;
              _context2.next = 4;
              return deleteFavorite({
                queryParams: {
                  live: isPlaying
                },
                requestBody: [{
                  permalink: category.permalink
                }]
              });

            case 4:
              dispatch(app_store_slices_user__WEBPACK_IMPORTED_MODULE_2__/* .userActions.loadFavorites */ .hI.loadFavorites());
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);
              console.error(_context2.t0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 7]]);
    }));

    return function removeFromFavorites(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var isFavoriteCategory = function isFavoriteCategory(category) {
    return !!(0,app_model_category__WEBPACK_IMPORTED_MODULE_7__/* .findCategory */ .b5)(favorites || [], category);
  };

  var toggleFavorite = /*#__PURE__*/function () {
    var _ref3 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(category) {
      var isPlaying,
          _args3 = arguments;
      return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              isPlaying = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : false;

              if (!(session !== null && session !== void 0 && session.user)) {
                _context3.next = 5;
                break;
              }

              if (!favoritesPending) {
                if (isFavoriteCategory(category)) {
                  removeFromFavorites(category, isPlaying);
                } else {
                  addToFavorites(category, isPlaying);
                }
              }

              _context3.next = 11;
              break;

            case 5:
              if (!customAuthGuard) {
                _context3.next = 10;
                break;
              }

              _context3.next = 8;
              return customAuthGuard();

            case 8:
              _context3.next = 11;
              break;

            case 10:
              navigatePath('/log-in');

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function toggleFavorite(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  return {
    toggleFavorite: toggleFavorite,
    isFavoriteCategory: isFavoriteCategory,
    loading: favoritesPending,
    addToFavorites: addToFavorites,
    removeFromFavorites: removeFromFavorites
  };
};

/***/ }),

/***/ 51027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZH": function() { return /* binding */ getStationLiveLogo; },
/* harmony export */   "b5": function() { return /* binding */ findCategory; },
/* harmony export */   "n6": function() { return /* binding */ getArtistName; },
/* harmony export */   "tw": function() { return /* binding */ getStationTitle; }
/* harmony export */ });
var findCategory = function findCategory(categories, category) {
  return categories.find(function (categoryItem) {
    return categoryItem.permalink === category.permalink;
  });
};
var getStationLiveLogo = function getStationLiveLogo(metadata, fallback) {
  var _metadata$body;

  if (metadata !== null && metadata !== void 0 && (_metadata$body = metadata.body) !== null && _metadata$body !== void 0 && _metadata$body.content) {
    var _metadata$body2, _metadata$body2$conte, _metadata$body2$conte2, _metadata$body4, _metadata$body4$conte, _metadata$body4$conte2, _metadata$body4$conte3, _metadata$body6, _metadata$body6$conte, _metadata$body6$conte2;

    if ((_metadata$body2 = metadata.body) !== null && _metadata$body2 !== void 0 && (_metadata$body2$conte = _metadata$body2.content) !== null && _metadata$body2$conte !== void 0 && (_metadata$body2$conte2 = _metadata$body2$conte.track) !== null && _metadata$body2$conte2 !== void 0 && _metadata$body2$conte2.cover) {
      var _metadata$body3, _metadata$body3$conte, _metadata$body3$conte2;

      return (_metadata$body3 = metadata.body) === null || _metadata$body3 === void 0 ? void 0 : (_metadata$body3$conte = _metadata$body3.content) === null || _metadata$body3$conte === void 0 ? void 0 : (_metadata$body3$conte2 = _metadata$body3$conte.track) === null || _metadata$body3$conte2 === void 0 ? void 0 : _metadata$body3$conte2.cover;
    }

    if ((_metadata$body4 = metadata.body) !== null && _metadata$body4 !== void 0 && (_metadata$body4$conte = _metadata$body4.content) !== null && _metadata$body4$conte !== void 0 && (_metadata$body4$conte2 = _metadata$body4$conte.track) !== null && _metadata$body4$conte2 !== void 0 && (_metadata$body4$conte3 = _metadata$body4$conte2.album) !== null && _metadata$body4$conte3 !== void 0 && _metadata$body4$conte3.cover) {
      var _metadata$body5, _metadata$body5$conte, _metadata$body5$conte2, _metadata$body5$conte3;

      return (_metadata$body5 = metadata.body) === null || _metadata$body5 === void 0 ? void 0 : (_metadata$body5$conte = _metadata$body5.content) === null || _metadata$body5$conte === void 0 ? void 0 : (_metadata$body5$conte2 = _metadata$body5$conte.track) === null || _metadata$body5$conte2 === void 0 ? void 0 : (_metadata$body5$conte3 = _metadata$body5$conte2.album) === null || _metadata$body5$conte3 === void 0 ? void 0 : _metadata$body5$conte3.cover;
    }

    if ((_metadata$body6 = metadata.body) !== null && _metadata$body6 !== void 0 && (_metadata$body6$conte = _metadata$body6.content) !== null && _metadata$body6$conte !== void 0 && (_metadata$body6$conte2 = _metadata$body6$conte.show) !== null && _metadata$body6$conte2 !== void 0 && _metadata$body6$conte2.logo) {
      var _metadata$body7, _metadata$body7$conte, _metadata$body7$conte2;

      return (_metadata$body7 = metadata.body) === null || _metadata$body7 === void 0 ? void 0 : (_metadata$body7$conte = _metadata$body7.content) === null || _metadata$body7$conte === void 0 ? void 0 : (_metadata$body7$conte2 = _metadata$body7$conte.show) === null || _metadata$body7$conte2 === void 0 ? void 0 : _metadata$body7$conte2.logo;
    }
  }

  return fallback;
};
var getStationTitle = function getStationTitle(metadata, stationName) {
  var _metadata$body8, _metadata$body8$conte, _metadata$body8$conte2, _metadata$body10, _metadata$body10$cont, _metadata$body10$cont2;

  if ((_metadata$body8 = metadata.body) !== null && _metadata$body8 !== void 0 && (_metadata$body8$conte = _metadata$body8.content) !== null && _metadata$body8$conte !== void 0 && (_metadata$body8$conte2 = _metadata$body8$conte.show) !== null && _metadata$body8$conte2 !== void 0 && _metadata$body8$conte2.name) {
    var _metadata$body9, _metadata$body9$conte, _metadata$body9$conte2;

    return "".concat(stationName, " - ").concat((_metadata$body9 = metadata.body) === null || _metadata$body9 === void 0 ? void 0 : (_metadata$body9$conte = _metadata$body9.content) === null || _metadata$body9$conte === void 0 ? void 0 : (_metadata$body9$conte2 = _metadata$body9$conte.show) === null || _metadata$body9$conte2 === void 0 ? void 0 : _metadata$body9$conte2.name);
  } else if ((_metadata$body10 = metadata.body) !== null && _metadata$body10 !== void 0 && (_metadata$body10$cont = _metadata$body10.content) !== null && _metadata$body10$cont !== void 0 && (_metadata$body10$cont2 = _metadata$body10$cont.track) !== null && _metadata$body10$cont2 !== void 0 && _metadata$body10$cont2.name) {
    var _metadata$body11, _metadata$body11$cont, _metadata$body11$cont2;

    return "".concat(stationName, " - ").concat((_metadata$body11 = metadata.body) === null || _metadata$body11 === void 0 ? void 0 : (_metadata$body11$cont = _metadata$body11.content) === null || _metadata$body11$cont === void 0 ? void 0 : (_metadata$body11$cont2 = _metadata$body11$cont.track) === null || _metadata$body11$cont2 === void 0 ? void 0 : _metadata$body11$cont2.name);
  } else {
    return stationName;
  }
};
var getArtistName = function getArtistName(metadata) {
  var _metadata$body12;

  if ((_metadata$body12 = metadata.body) !== null && _metadata$body12 !== void 0 && _metadata$body12.content) {
    var _metadata$body13, _metadata$body13$cont, _metadata$body13$cont2, _metadata$body13$cont3;

    if ((_metadata$body13 = metadata.body) !== null && _metadata$body13 !== void 0 && (_metadata$body13$cont = _metadata$body13.content) !== null && _metadata$body13$cont !== void 0 && (_metadata$body13$cont2 = _metadata$body13$cont.track) !== null && _metadata$body13$cont2 !== void 0 && (_metadata$body13$cont3 = _metadata$body13$cont2.artist) !== null && _metadata$body13$cont3 !== void 0 && _metadata$body13$cont3.name) {
      var _metadata$body14, _metadata$body14$cont, _metadata$body14$cont2, _metadata$body14$cont3;

      return (_metadata$body14 = metadata.body) === null || _metadata$body14 === void 0 ? void 0 : (_metadata$body14$cont = _metadata$body14.content) === null || _metadata$body14$cont === void 0 ? void 0 : (_metadata$body14$cont2 = _metadata$body14$cont.track) === null || _metadata$body14$cont2 === void 0 ? void 0 : (_metadata$body14$cont3 = _metadata$body14$cont2.artist) === null || _metadata$body14$cont3 === void 0 ? void 0 : _metadata$body14$cont3.name;
    }
  }
};

/***/ }),

/***/ 35504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ favorites; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./app/components/icons/FavoritesNoAccount.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var FavoritesNoAccount = function FavoritesNoAccount(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 232 207",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M53.994 95.765c-2.513 2.528-6.36 2.676-9.164.711l-.177.178-5.109-5.156c-14.106-14.228-14.106-37.3 0-51.53a7.181 7.181 0 0110.214 0c2.827 2.844 2.827 7.46 0 10.303-8.459 8.541-8.459 22.384 0 30.917l5.109 5.156-.177.178c1.962 2.852 1.817 6.708-.696 9.243zm18.68-51.013c-2.828-2.844-2.828-7.459 0-10.302a7.162 7.162 0 0110.213 0c2.82 2.843 2.82 7.458 0 10.302a7.177 7.177 0 01-10.214 0zm140.547 67.362l-46.339 46.74a7.178 7.178 0 01-10.211 0 7.316 7.316 0 010-10.306l41.227-41.59 5.105-5.156c17.943-18.101 19.749-52.218 0-72.145-19.747-19.918-51.764-19.918-71.511 0l-5.055 5.101c-2.621 2.667-6.254 4.329-10.275 4.329-4.014 0-7.646-1.662-10.266-4.329l-5.057-5.1c-19.744-19.919-51.764-19.919-71.508 0-19.754 19.926-18.397 53.594 0 72.144l15.322 15.461 76.621 77.299c2.818 2.843 2.818 7.459 0 10.305a7.182 7.182 0 01-10.214 0l-40.868-41.22-51.082-51.533c-24.035-24.247-25.392-67.145 0-92.76 25.39-25.615 66.558-25.615 91.95 0l5.109 5.156 5.104-5.156c25.39-25.615 66.558-25.615 91.948 0 25.394 25.615 23.133 69.417 0 92.76zm-64.289 54.547c2.818 2.843 2.818 7.458 0 10.309a7.188 7.188 0 01-10.223 0c-2.818-2.851-2.818-7.466 0-10.309a7.186 7.186 0 0110.223 0z",
      fill: "#4A6EFF"
    })
  }));
};

var MemoFavoritesNoAccount = /*#__PURE__*/react.memo(FavoritesNoAccount);
/* harmony default export */ var icons_FavoritesNoAccount = (MemoFavoritesNoAccount);
// EXTERNAL MODULE: ./app/components/ui/button.component.tsx
var button_component = __webpack_require__(61947);
// EXTERNAL MODULE: ./app/components/auth/favorites-auth-guard.module.scss
var favorites_auth_guard_module = __webpack_require__(51744);
var favorites_auth_guard_module_default = /*#__PURE__*/__webpack_require__.n(favorites_auth_guard_module);
// EXTERNAL MODULE: ./app/components/auth/auth.component.tsx + 7 modules
var auth_component = __webpack_require__(35052);
// EXTERNAL MODULE: ./app/hooks/keyboard-navigation.hook.ts
var keyboard_navigation_hook = __webpack_require__(36158);
// EXTERNAL MODULE: ./app/components/ui/portal.tsx + 1 modules
var portal = __webpack_require__(64263);
// EXTERNAL MODULE: ./app/hooks/modal-scroll.hook.ts
var modal_scroll_hook = __webpack_require__(76299);
// EXTERNAL MODULE: ./app/hooks/lang.ts + 22 modules
var lang = __webpack_require__(91289);
// EXTERNAL MODULE: ./app/hooks/go-back.hook.ts
var go_back_hook = __webpack_require__(71014);
;// CONCATENATED MODULE: ./app/components/auth/favorites-auth-guard.component.tsx













var FavoritesAuthGuard = function FavoritesAuthGuard(_ref) {
  var onClose = _ref.onClose;
  var t = (0,lang/* useTranslate */.q)();

  var _useState = (0,react.useState)(false),
      showAuth = _useState[0],
      setShowAuth = _useState[1];

  var popupId = (0,go_back_hook/* useGoBackEvent */.H)("FavoritesAuthGuard", function () {
    setShowAuth(false);
  }, showAuth);
  var authCloseCallback = (0,react.useCallback)(function () {
    setShowAuth(false);
  }, [setShowAuth]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: showAuth ? /*#__PURE__*/(0,jsx_runtime.jsx)(auth_component/* Auth */.g, {
      parentPopupId: popupId,
      onClose: authCloseCallback,
      onSuccess: onClose
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (favorites_auth_guard_module_default()).no_account,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (favorites_auth_guard_module_default()).icon,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_FavoritesNoAccount, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (favorites_auth_guard_module_default()).content,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
          className: (favorites_auth_guard_module_default()).title,
          children: t("header.menu.favorites")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (favorites_auth_guard_module_default()).subtitle,
          children: t("you-dont-have-favorites")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-navigate-row": true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* Button */.zx, {
            "data-navigate-item": true,
            onClick: function onClick() {
              return setShowAuth(true);
            },
            className: (favorites_auth_guard_module_default()).button,
            children: t("create-an-account")
          })
        }), onClose && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            "data-navigate-row": true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* ButtonText */.oD, {
              "data-navigate-item": true,
              onClick: function onClick() {
                return onClose();
              },
              className: (favorites_auth_guard_module_default()).button,
              children: t("close")
            })
          })]
        })]
      })]
    })
  });
};
var FavoritesAuthGuardPopup = function FavoritesAuthGuardPopup(_ref2) {
  var onClose = _ref2.onClose;
  var wrapperRef = useArrowKeyNavigationOverlay();
  useModalScroll();
  var goBackCallback = useCallback(function () {
    onClose();
  }, [onClose]);
  useGoBackEvent("FavoritesAuthGuardPopup", goBackCallback);
  return /*#__PURE__*/_jsx(Portal, {
    children: /*#__PURE__*/_jsx("div", {
      className: styles.wrapper,
      ref: wrapperRef,
      children: /*#__PURE__*/_jsx(FavoritesAuthGuard, {
        onClose: onClose
      })
    })
  });
};
// EXTERNAL MODULE: ./app/components/podcats-list/podcast-list.component.tsx
var podcast_list_component = __webpack_require__(60151);
// EXTERNAL MODULE: ./app/components/stations-list/stations-list.component.tsx
var stations_list_component = __webpack_require__(79666);
// EXTERNAL MODULE: ./app/components/no-ssr.component.tsx
var no_ssr_component = __webpack_require__(92290);
// EXTERNAL MODULE: ./app/store/slices/user.ts
var user = __webpack_require__(38886);
// EXTERNAL MODULE: ./app/store/store.ts
var store = __webpack_require__(4062);
// EXTERNAL MODULE: ./pages/favorites/index.module.scss
var index_module = __webpack_require__(88751);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./app/store/slices/player.ts
var player = __webpack_require__(22564);
// EXTERNAL MODULE: ./app/hooks/favorites.hook.ts
var favorites_hook = __webpack_require__(18958);
// EXTERNAL MODULE: ./app/context/player.context.tsx
var player_context = __webpack_require__(48346);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./app/components/icons/HeartOutline.tsx
var HeartOutline = __webpack_require__(9761);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./pages/favorites/index.tsx






















var Home = function Home() {
  var _activeMedia$category2;

  var router = (0,next_router.useRouter)();
  var _router$query = router.query,
      permalink = _router$query.permalink,
      toggle = _router$query.toggle,
      autoplay = _router$query.autoplay;

  var _usePlayerContext = (0,player_context/* usePlayerContext */.gD)(),
      setPlayerEnabled = _usePlayerContext.setPlayerEnabled;

  var _useAppSelector = (0,store/* useAppSelector */.CG)(user/* selectUserState */.tH),
      session = _useAppSelector.session,
      favorites = _useAppSelector.favorites,
      favoritesLoading = _useAppSelector.favoritesLoading;

  var _useState = (0,react.useState)(false),
      autoplayEnabled = _useState[0],
      setAutoplayEnabled = _useState[1];

  var _useMemo = (0,react.useMemo)(function () {
    return {
      autoPermalink: permalink || "",
      autoToggle: toggle || "",
      autoPlay: autoplay || ""
    };
  }, [permalink, toggle, autoplay]),
      autoPermalink = _useMemo.autoPermalink,
      autoToggle = _useMemo.autoToggle,
      autoPlay = _useMemo.autoPlay;

  var _useFavorites = (0,favorites_hook/* useFavorites */.r)(),
      toggleFavorite = _useFavorites.toggleFavorite;

  (0,react.useEffect)(function () {
    if (autoToggle === "true") {
      toggleFavorite({
        permalink: autoPermalink
      });
    }

    if (autoplay === "true") {
      setAutoplayEnabled(true);
    }
  }, [autoPermalink, autoToggle, autoplay]);
  var dispatch = (0,store/* useAppDispatch */.TL)();
  (0,react.useEffect)(function () {
    if (session !== null && session !== void 0 && session.user) {
      dispatch(user/* userActions.loadFavorites */.hI.loadFavorites());
    }
  }, [session, dispatch]);

  var _useAppSelector2 = (0,store/* useAppSelector */.CG)(player/* selectPlayerState */.tA),
      failedPlaybackPermalink = _useAppSelector2.failedPlaybackPermalink,
      activeMedia = _useAppSelector2.activeMedia;

  var stations = (0,react.useMemo)(function () {
    return favorites.filter(function (category) {
      return category.type === "radio";
    });
  }, [favorites]);
  var podcasts = (0,react.useMemo)(function () {
    return favorites.filter(function (category) {
      return category.type === "podcast";
    });
  }, [favorites]);
  (0,react.useEffect)(function () {
    if (autoplayEnabled && session !== null && session !== void 0 && session.user && stations.length > 0) {
      var playIndex = 0;
      var play = true;

      if (failedPlaybackPermalink) {
        var permalinks = stations.map(function (item) {
          return item.permalink;
        });
        var found = permalinks.lastIndexOf(failedPlaybackPermalink);

        if (found > -1 && found < stations.length - 1) {
          playIndex = found + 1;
        } else if (found === stations.length - 1) {
          play = false;
        }
      }

      if (play) {
        var _activeMedia$category;

        if ((activeMedia === null || activeMedia === void 0 ? void 0 : (_activeMedia$category = activeMedia.category) === null || _activeMedia$category === void 0 ? void 0 : _activeMedia$category.permalink) === stations[playIndex].permalink) {
          setAutoplayEnabled(false);
        }

        dispatch(player/* playerActions.setRadioQueue */.i9.setRadioQueue({
          items: stations,
          activeIndex: playIndex
        }));
        setPlayerEnabled(true);
        dispatch(player/* playerActions.selectTrack */.i9.selectTrack({
          podcast: null,
          category: stations[playIndex]
        }));
      }
    }
  }, [favorites, autoplayEnabled, failedPlaybackPermalink, activeMedia === null || activeMedia === void 0 ? void 0 : (_activeMedia$category2 = activeMedia.category) === null || _activeMedia$category2 === void 0 ? void 0 : _activeMedia$category2.permalink]);
  (0,go_back_hook/* useGoBackHistory */.J)("FAVORITES");
  var t = (0,lang/* useTranslate */.q)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t("header.menu.favorites"),
      titleTemplate: "%s - Radioline",
      description: t("header.menu.favorites") + " - Radioline",
      openGraph: {
        images: [{
          url: "https://www.radioline.co/open-graph.png",
          alt: "Radioline"
        }]
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (index_module_default()).container,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(no_ssr_component/* default */.Z, {
        children: session !== null && session !== void 0 && session.user ? favorites.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).stations_wrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(stations_list_component/* StationsList */.e, {
              items: stations,
              label: t("tabs.stations"),
              loading: favoritesLoading,
              rows: 2
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(podcast_list_component/* PodcastList */.k, {
            items: podcasts,
            label: t("tabs.podcasts"),
            loading: favoritesLoading,
            rows: 3,
            itemClassName: (index_module_default()).favorites_podcast
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default()).no_account,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).icon,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_FavoritesNoAccount, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default()).content,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: (index_module_default()).title,
              children: t("header.menu.favorites")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (index_module_default()).subtitle,
              children: t("favorites.no-favotites")
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: (0,clsx_m/* default */.Z)((index_module_default()).subtitle, (index_module_default()).with_icon),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (index_module_default()).icon_wrapper,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeartOutline/* default */.Z, {})
              }), t("search-for-stations")]
            })]
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(FavoritesAuthGuard, {})
      })
    })]
  });
};

/* harmony default export */ var favorites = (Home);

/***/ }),

/***/ 9025:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/favorites",
      function () {
        return __webpack_require__(35504);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51744:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","wrapper":"favorites-auth-guard_wrapper__DKuCv","no_account":"favorites-auth-guard_no_account__AaiG3","content":"favorites-auth-guard_content__010Dv","title":"favorites-auth-guard_title__sUx4o","subtitle":"favorites-auth-guard_subtitle__kXWiE","with_icon":"favorites-auth-guard_with_icon__rMU_F","icon_wrapper":"favorites-auth-guard_icon_wrapper__6ITUI","button":"favorites-auth-guard_button___7b62","icon":"favorites-auth-guard_icon__G7cPX"};

/***/ }),

/***/ 88751:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","container":"favorites_container__vUrR_","no_account":"favorites_no_account__9uPcv","content":"favorites_content__u3Vc9","title":"favorites_title__l99Qv","subtitle":"favorites_subtitle__a5jqS","with_icon":"favorites_with_icon__7OPT3","icon_wrapper":"favorites_icon_wrapper__OlWVM","button":"favorites_button__1E7_P","icon":"favorites_icon__jufUa","stations_wrapper":"favorites_stations_wrapper__HwThQ","favorites_podcast":"favorites_favorites_podcast__t2WhH"};

/***/ }),

/***/ 43337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useInterval = function (callback, delay) {
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () { });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        savedCallback.current = callback;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (delay !== null) {
            var interval_1 = setInterval(function () { return savedCallback.current(); }, delay || 0);
            return function () { return clearInterval(interval_1); };
        }
        return undefined;
    }, [delay]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useInterval);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9273,5675,2962,5052,6694,4357,9774,2888,179], function() { return __webpack_exec__(9025); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);